export default __webpack_public_path__ + "static/media/template_pro__0022_5---JasonKoon.c9ec44c3.png";